<template>
  <div class="card mb-4" id="tooltips">
    <div class="card-header">
      <h3>Tooltip</h3>
    </div>
    <div class="card-body">
      <div class="mb-3">
        <button class="btn btn-primary" v-tooltip="`Tooltip default`">
          Tooltip default
        </button>
      </div>
      <pre>
&lt;button class="btn btn-primary" v-tooltip="`Tooltip default`"&gt;Tooltip default&lt;/button&gt;</pre
      >

      <div class="mb-3">
        <button class="btn btn-primary" v-tooltip.bottom="`Tooltip bottom`">
          Tooltip bottom
        </button>
      </div>
      <pre>
&lt;button class="btn btn-primary" v-tooltip.bottom="`Tooltip default`"&gt;Tooltip default&lt;/button&gt;</pre
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Tooltips",
};
</script>
